var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(this.start),expression:"this.start"}],staticClass:"window"},[(_vm.isLocked)?_c('LockedScreen'):_c('HomeScreen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }